import React, { useMemo } from 'react';
import ReactSelect, { Props } from 'react-select';
import { defaultSelectStyles } from './Select.styles';
import { extractFormCellProps, FormCell, IFormCellProps } from '../FormCell';
import { mergeTests } from '../../test-utilities/mergeTests';
import { ILabelValue } from '../../utilities/ILabelValue';
import { ErrorBoundaryConstellation } from '../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';

export interface ISelectProps extends Props<any>, Omit<IFormCellProps, 'disabled'> {
  /** @Deprecated readOnly is the same as isDisabled at the Select Level */
  readOnly?: boolean;
}

export interface ISelectOption<Value = any> extends ILabelValue<string, Value> {
  /** @Deprecated groups should be handled by ISelectGroup*/
  group?: string;
  isDisabled?: boolean;
}

export interface ISelectGroup<Value = any> {
  label: string;
  options: ISelectOption<Value>[];
}

/**
 * Select component presents a menu of options.
 */
export const Select: React.FC<ISelectProps> = (props) => {
  const { formCellProps, inputProps } = extractFormCellProps(props);
  const styles = useMemo(() => ({ ...defaultSelectStyles, ...inputProps.styles }), [inputProps.styles]);

  return (
    <ErrorBoundaryConstellation>
      <FormCell {...formCellProps} disabled={inputProps.isDisabled} data-test-id={props['data-test-id']}>
        <ReactSelect
          {...inputProps}
          styles={styles}
          data-test-id={mergeTests(props['data-test-id'], 'input')}
          isDisabled={inputProps.isDisabled}
          className="select"
          classNamePrefix="select"
        />
      </FormCell>
    </ErrorBoundaryConstellation>
  );
};
